module.exports = __webpack_public_path__ + "img/bg03.cf4ddc2b.gif";